import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const crm: AppRouteModule = {
  path: '/crm',
  name: 'Crm',
  component: LAYOUT,
  redirect: '/crm/setting',
  meta: {
    icon: 'carbon:id-management',
    title: '客户管理',
    auth: 'crm',
    orderNo: 60,
  },
  children: [
    {
      path: 'setting',
      name: 'CRMSetting',
      component: () => import('/@/views/admin/seas-config/index.vue'),
      meta: {
        title: '客户公海配置列表',
        ignoreKeepAlive: false,
        auth: 'crm.pool',
      },
    },
    {
      path: 'allotSetting',
      name: 'CRMAllotSetting',
      component: LAYOUT,
      meta: {
        title: '分配配置',
      },
      children: [
        {
          path: 'allotUserSetting',
          name: 'CRMAllotUserSetting',
          component: () => import('/@/views/admin/allot-user-setting/index.vue'),
          meta: {
            title: '可分配成员配置',
            ignoreKeepAlive: false,
            auth: 'crm.setting',
          },
        },
        {
          path: 'allotOtherSetting',
          name: 'CRMAllotOtherSetting',
          component: () => import('/@/views/admin/allot-user-setting/other.vue'),
          meta: {
            title: '其他配置',
            ignoreKeepAlive: false,
            auth: 'crm.setting',
          },
        },
      ],
    },
    {
      path: 'businessSetting',
      name: 'CRMBusinessSetting',
      component: LAYOUT,
      meta: {
        title: '商机配置',
      },
      children: [
        {
          path: 'businessTypesSetting',
          name: 'CRMBusinessTypesSetting',
          component: () => import('/@/views/admin/business/BusinessTypes.vue'),
          meta: {
            title: '商机类型配置',
            ignoreKeepAlive: false,
            auth: 'crm.setting',
          },
        },
        {
          path: 'businessReasonSetting',
          name: 'CRMBusinessReasonSetting',
          component: () => import('/@/views/admin/business/BusinessReason.vue'),
          meta: {
            title: '商机未成交原因配置',
            ignoreKeepAlive: false,
            auth: 'crm.setting',
          },
        },
        {
          path: 'businessFollowSetting',
          name: 'CRMBusinessFollowSetting',
          component: () => import('/@/views/admin/business/BusinessFollowReason.vue'),
          meta: {
            title: '商机跟进中原因配置',
            ignoreKeepAlive: false,
            auth: 'crm.setting',
          },
        },
      ],
    },
    {
      path: 'ECCustomer',
      name: 'CRMECCustomer',
      component: () => import('/@/views/admin/customer/ECCustomer.vue'),
      meta: {
        title: '淘宝客户配置',
        ignoreKeepAlive: false,
        auth: 'crm.setting',
      },
    },
    {
      path: 'Source',
      name: 'CRMSource',
      component: () => import('/@/views/admin/customer/Source.vue'),
      meta: {
        title: '客户来源配置',
        ignoreKeepAlive: false,
        auth: 'crm.setting',
      },
    },
    {
      path: 'tianyanchaSetting',
      name: 'CRMTianYanChaSetting',
      component: () => import('/@/views/admin/tainyancha/index.vue'),
      meta: {
        title: '天眼查更新',
        ignoreKeepAlive: false,
        auth: 'crm.tycupdate',
      },
    },
    {
      path: 'DelaySpecialSetting',
      name: 'CRMDelaySpecialSetting',
      component: () => import('/@/views/admin/customer/DelaySpecial.vue'),
      meta: {
        title: '逾期跟进特殊配置',
        ignoreKeepAlive: false,
        auth: 'crm.setting',
      },
    },
    {
      path: 'CustomerRuleSetting',
      name: 'CRMCustomerRuleSetting',
      component: () => import('/@/views/admin/customer/CustomerRule.vue'),
      meta: {
        title: '客户分类规则设置',
        ignoreKeepAlive: false,
        auth: 'crm.setting',
      },
    },
  ],
};

export default crm;
